import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { AvailabilityMessageType } from "@insite/client-framework/Types/ApiModels";
import * as React from "react";

interface OwnProps {
    productContext: ProductContextModel;
}
type props = OwnProps;

const SeoProductDetail: React.FC<props> = ({ productContext }) => {
    const product = productContext.product;
    const pricing = productContext.productInfo.pricing;
    const inventory = productContext.productInfo.inventory;
    const availability =
        inventory?.inventoryAvailabilityDtos?.find(
            o => o.unitOfMeasure.toLowerCase() === (productContext.productInfo.unitOfMeasure?.toLowerCase() || ""),
        )?.availability || undefined;

    return (
        <div>
            {(pricing && pricing.unitNetPrice) ? (
                <div itemType="https://schema.org/Product" itemScope>
                    <link itemProp="image" href={product.mediumImagePath} />
                    <meta itemProp="name" content={product.productTitle} />
                    <meta itemProp="mpn" content={product.manufacturerItem} />
                    <meta itemProp="sku" content={product.productNumber} />
                    <meta itemProp="description" content={product.properties.longDescription1} />
                    <div itemProp="brand" itemType="https://schema.org/Brand" itemScope>
                        <meta itemProp="name" content={product.brand?.name} />
                    </div>
                    <div itemProp="offers" itemType="https://schema.org/Offer" itemScope>
                        <meta itemProp="price" content={`${pricing?.unitNetPrice.toFixed(2)}`} />
                        <meta itemProp="priceCurrency" content="USD" />
                        <meta itemProp="url" content={product.canonicalUrl} />
                        {availability && availability.messageType === AvailabilityMessageType.Available && (
                            <meta itemProp="availability" content="https://schema.org/InStock" />
                        )}
                        {availability && availability.messageType === AvailabilityMessageType.OutOfStock && (
                            <meta itemProp="availability" content="https://schema.org/OutOfStock" />
                        )}
                    </div>
                </div>
            ): null}
        </div>
    );
};

export default SeoProductDetail;
